import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2v12H6V6zm3.5 6l8.5 6V6l-8.5 6z"
}), 'SkipPreviousSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SkipPreviousSharp.js
// module id = 6271
// module chunks = 2